import React from "react";

const ProjectInfo = () => {
    return (
        <div>
            <h1>ProjectConfig</h1>
        </div>
    );
};

export default ProjectInfo;